import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getAllPuckPagesQueryKey } from "./useGetAllPuckPages";
import { clearPersistedCache } from "src/_Globals/queryClient/cachePersistence";

type DeletePuckPageOptions = {
    slug: string;
};

export const useDeletePuckPage = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, DeletePuckPageOptions>({
        mutationFn: async (options: DeletePuckPageOptions) => {
            const { slug } = options;
            await loggedInApiCall.delete(`/api/cms/puck/page/${slug}`);
        },
        onSuccess: () => {
            // Clear localStorage first
            clearPersistedCache();

            // Force remove caches
            queryClient.removeQueries([getAllPuckPagesQueryKey]);

            // Force immediate refetch
            queryClient.refetchQueries([getAllPuckPagesQueryKey], { exact: false });
        },
    });
};
